export type ITool = {
  title: string
  url: string
  description: string
}

export const resourceList: ITool[] = [
  {
    title: 'Tree Management',
    url: 'https://kat.kiddom.co/tree/management/<kiddomTreeID>',
    description: 'Tree Management, duplicate tree, hopefully other stuff',
  },
  {
    title: 'Builder',
    url: 'https://kat.kiddom.co/builder/',
    description:
      'Explore existing trees; useful for verifying structure. Fix question issues including deleting/adding extra/missing question answer list, fixing placholder list, changing placeholder external ids, placeholder missing targets, target missing external id, set points value, delete duplicate leaf types,',
  },
  {
    title: 'Verify',
    url: 'https://kat.kiddom.co/tree/verify/',
    description: 'Use this to verify tree has all required verifications',
  },
  {
    title: 'ID editable copy verification',
    url: 'https://kat.kiddom.co/id_verification',
    description: 'Verify master editable copies are in a good state',
  },
  {
    title: 'Master',
    url: 'https://kat.kiddom.co/master/',
    description: 'Index of all current bundled curricula',
  },
  {
    title: 'Curricula Version Update',
    url: 'https://kat.kiddom.co/curricula_version_update/',
    description:
      'Use this tool to create a new version for existing bundled curricula\nYou are able to use existing trees or trees from local files. Either way a new tree is created for the version update.\nThe tool will attempt to automatically find the curricula you are updating from based on the title. If it is not successful finding the existing version make sure what you have is correct. The version will be automatically incremented but can be overridden. If you are in the production environment you will see curricula with matching attribution outlined in green.\nWhen Publishing starts the first thing that happens is\n1: We send the entire tree as stringified JSON to PUT /api/tree/[treeIdOfPreviousVersion]:[versionIdOfPreviousVersion] The result of this is a new tree with the same tree id as the previous version (the master tree id stays the same across versions) with a new version id\n2: We then POST a publishTree query using the new tree id, version and version name. This adds an entry in the named_version table, this is how we identify published/master/bundled curricula.',
  },
  {
    title: 'Student Teacher Fix',
    url: 'https://kat.kiddom.co/user/student_teacher_fix/',
    description:
      'Paste in line separated student emails. This tool will verify which ones need to be fixed.',
  },
  {
    title: 'Production Master import',
    url: 'https://kat.kiddom.co/masters_import/',
    description:
      'Import masters into environment such as staging. Importing is not allowed in production',
  },
  {
    title: 'admin introspection',
    url: 'https://kat.kiddom.co/admin/introspection/',
    description: 'See what admin queries/mutations are available',
  },
  {
    title: 'Master Tree',
    url: 'https://kat.kiddom.co/master/<tree_id>',
    description: 'See tree versions and migrate schools',
  },
  {
    title: 'Master Update',
    url: 'https://kat.kiddom.co/master/<tree_id>/publish',
    description: 'Publish new version of curriculum',
  },
  {
    title: 'Master Update Validation',
    url: 'https://kat.kiddom.co/master:<tree_version_node_id>',
    description: 'Verify tree meets requiremets for master update',
  },
  {
    title: 'Master Tracked Copies',
    url: 'https://kat.kiddom.co/master/<tree_id>/tracked_copies',
    description:
      'Tracked copies associated with the different versions of a master',
  },
  {
    title: 'Content Upload',
    url: 'https://kat.kiddom.co/content_upload',
    description: 'Tool for uploading content to be included in curricula',
  },
  {
    title: 'Version Mapping',
    url: 'https://kat.kiddom.co/version_mapping',
    description: 'Curricula version mapping management',
  },
  {
    title: 'Curricula Version Migrate',
    url: 'https://kat.kiddom.co/curricula_version_migrate',
    description: 'Migrate bundled curricula',
  },
  {
    title: 'Node Reorder',
    url: 'https://kat.kiddom.co/node_reorder',
    description: 'Reorder the child nodes',
  },
  {
    title: 'Masters Verification',
    url: 'https://kat.kiddom.co/masters_verification',
    description: 'Verify if we can migrate to a new version',
  },
  {
    title: 'SVG Convert Container',
    url: 'https://kat.kiddom.co/svg_convert',
    description: 'SVG convert for drawing background',
  },
  {
    title: 'SVG Check',
    url: 'https://kat.kiddom.co/svg_check',
    description: 'Check which masters have svg background images',
  },
  {
    title: 'Bad Questions',
    url: 'https://kat.kiddom.co/bad_questions',
    description: 'Dispaly of questions that are in bad state',
  },
  {
    title: 'Presentations Fix',
    url: 'https://kat.kiddom.co/presentations_fix',
    description: 'Verify that editable links are using read only presentations',
  },
  {
    title: 'Ingestion',
    url: 'https://kat.kiddom.co/ingestion',
    description:
      'Index page for selecting a partner curriculum; from there can proceed to ingest files provided by our partners',
  },
  {
    title: 'Partner',
    url: 'https://kat.kiddom.co/ingestion/partner/<partner_key>',
    description:
      'View previously ingested files and upload new files for ingestiong',
  },
  {
    title: 'Partner Ingested',
    url: 'https://kat.kiddom.co/ingestion/partner/<partner_key>/ingested',
    description:
      'preview simplified JSON files which will be turned into kiddom trees',
  },
  {
    title: 'Ingested Item',
    url: 'https://kat.kiddom.co/ingestion/partner/<partner_key>/ingested/<ingestion_id>',
    description: 'This shows the ingested version',
  },
  {
    title: 'Ingestion Test',
    url: 'https://kat.kiddom.co/ingestion-engine/<partner_id>',
    description:
      'Take sample input files from partner and turn them into simplified json',
  },
  {
    title: 'District Manager',
    url: 'https://kat.kiddom.co/districts/<district_id>/show',
    description:
      'Add new and existing schools to district. Add or delete curriculum. Edit district details',
  },
  {
    title: 'Users',
    url: 'https://kat.kiddom.co/users',
    description: 'Create user and export users',
  },
  {
    title: 'Schools',
    url: 'https://kat.kiddom.co/schools',
    description: 'Create and export schools',
  },
]
